import { PARTNER_CONSENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export enum PARTNER {
    twinhealth = 'twinhealth',
}

export default (profile: {
    patientid: string;
    pxid: string;
    visitid: string;
    partner: PARTNER;
    notes?: string;
}): Promise<{ success: boolean }> => {
    return fetchWithRefresh(PARTNER_CONSENT, {
        method: 'POST',
        body: JSON.stringify(profile),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
